import { DragOverlay, useDndContext } from '@dnd-kit/core';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { PdfGridSquare } from './PdfGridSquare';

/**
 * Renders a copy of a page that is anchored to the mouse when dragging and dropping
 */
export const DragOverlayContent = () => {
  const { palette } = useTheme();

  const { active } = useDndContext();
  return (
    <DragOverlay dropAnimation={null}>
      <PdfGridSquare
        pageNumber={Number(active?.id ?? 0)}
        isCurrentPage={false}
        isSelected={false}
        isGrouped={false}
        groupNumber={0}
        positionInGroup={0}
        groupSize={1}
        groupColor={palette.info.light}
        groupBorderColor={palette.info.light}
      />
    </DragOverlay>
  );
};
